/**
 * Labstep
 *
 * @module components/Group/Settings/DefaultSignatureRequestMessage
 * @desc DefaultSignatureRequestMessage field update
 */

import { fieldGroupDefaultSignatureRequestMessage } from 'labstep-web/components/Group/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { GroupFormShowEditDefaultSignatureRequestMessageProps } from './types';

export const GroupFormShowEditDefaultSignatureRequestMessage: React.FC<
  GroupFormShowEditDefaultSignatureRequestMessageProps
> = ({ group }) => (
  <ShowEditText
    entityName={group.entityName}
    entity={group}
    field={fieldGroupDefaultSignatureRequestMessage}
  >
    {group.default_signature_request_message}
  </ShowEditText>
);
